module.exports = __webpack_public_path__ + "dist/media/logo--it.84700cc8.svg";